// import Vue from 'vue'
import axios from "axios";
import QS from "qs";
import Cookies from 'js-cookie'
import router from '../router'
import { Toast } from 'vant';
import getConf from '../../config/env'

axios.defaults.baseURL = getConf().baseUrl

axios.defaults.timeout = 100000;

axios.defaults.headers.post["Content-Type"] =
    "application/x-www-form-urlencoded;charset=UTF-8";

let writeNoToast = [
    'ndj-grange/app/v1/planting-notes/stage-page'
]

axios.interceptors.request.use(
    config => {
        if(writeNoToast.indexOf(config.url) > -1){
            //加载中
            Toast.loading({
                message: '加载中...',
                forbidClick: true
            });
        }
        return config;
    },
    error => {
        return Promise.error(error);
    }
);
axios.interceptors.response.use(
    response => {
        let returnCode = response.data.code;
        // 如果返回的状态码为200，说明接口请求成功，可以正常拿到数据
        // 否则的话抛出错误
        Toast.clear()
        if (response.status === 200) {
            // return Promise.reject(response);
            if(returnCode == 0){
                return Promise.resolve(response);
            }else{
                if( returnCode == 20006 || returnCode == 20001){
                  Toast.fail(response && response.data && response.data.msg || '服务异常');
                    return Promise.reject(response);
                }else{
                  Toast.fail(response && response.data && response.data.msg || '服务异常');
                    return Promise.reject(response);
                }
            }
        } else {
            return Promise.reject(response);
        }
    },

    // 服务器状态码不是2开头的的情况
    // 这里可以跟你们的后台开发人员协商好统一的错误状态码
    // 然后根据返回的状态码进行一些操作，例如登录过期提示，错误提示等等
    // 下面列举几个常见的操作，其他需求可自行扩展
    error => {
        if (error.response.status) {
            switch (error.response.status) {
                // 401: 未登录
                // 未登录则跳转登录页面，并携带当前页面的路径
                // 在登录成功后返回当前页面，这一步需要在登录页操作。
                case 401:
                    break;
                case 403:
                    break;
                // 404请求不存在
                case 404:
                    break;
                // 其他错误，直接抛出错误提示
            }
            return Promise.reject(error.response);
        }
    }
);




/**
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function Get(url, params) {
    return new Promise((resolve, reject) => {
        axios
            .get(url, {
                params: params
            })
            .then(res => {
                resolve(res.data);
            })
            .catch(err => {
                reject(err.data);
                throw err;
            });
    });
}

/**
 * 下载方法
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function Down(method, url, params) {
    return new Promise((resolve, reject) => {
        axios({ method, url, params, responseType: "blob" }).then(res => {
            resolve(res.data);
        }).catch(err => {
            reject(err.data);
            throw err;
        })
    });
}

/**
 * post方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function Post(url, params) {
    return new Promise((resolve, reject) => {
        axios
            .post(url, params,{
                headers: {
                    'Content-Type': 'application/json;charset=UTF-8'
                }
            })
            .then(res => {
                resolve(res.data);
            })
            .catch(err => {
                reject(err.data);
            });
    });
}


/**
 * put方法，对应put请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function Put(url, params) {
    params = QS.stringify(params, { arrayFormat: 'brackets' })
    return new Promise((resolve, reject) => {
        axios
            .put(url, params)
            .then(res => {
                resolve(res.data);
            })
            .catch(err => {
                reject(err.data);
            });
    });
}

/**
 * delete方法，对应delete请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function Delete(url, params) {
    params = QS.stringify(params, { arrayFormat: 'brackets' })
    return new Promise((resolve, reject) => {
        axios
            .delete(url, params)
            .then(res => {
                resolve(res.data);
            })
            .catch(err => {
                reject(err.data);
            });
    });
}


/**
 * 上传文件方法
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */

export function Update(url, params) {
    // params = QS.stringify(params, { arrayFormat: 'brackets' })
    return new Promise((resolve, reject) => {
        axios.post(url, params,
            {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }

        ).then(res => {
            resolve(res.data);
        }).catch(err => {
            reject(err.data);
            throw err;
        })
    });
}
